import { render, staticRenderFns } from "./Checkorder.vue?vue&type=template&id=36dc985f"
import script from "./Checkorder.vue?vue&type=script&lang=js"
export * from "./Checkorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports